import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import { areaForRole, homeForRole } from '@/lib/roles';
import { FieldLayout } from '@/components/layout/FieldLayout';

export function GateLayout() {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login?as=gate" replace />;

  /*
    Admins are allowed through: /codes/check and /codes/verify are authorised for
    `gateOrAdmin`, so a head teacher covering the gate can genuinely use this
    screen. Parents are not, and are sent to their own app.
  */
  const area = areaForRole(user?.role);
  if (area !== 'gate' && area !== 'admin') return <Navigate to={homeForRole(user?.role)} replace />;

  return (
    <FieldLayout appLabel="Gate" width="wide">
      <Outlet />
    </FieldLayout>
  );
}
